import { Button } from '@cian/ui-kit/button';
import * as React from 'react';

import { IShowMoreBtnProps } from '../types';

export const ShowMoreBtn: React.FC<IShowMoreBtnProps> = props => {
  const { onClick, loading } = props;

  return (
    <Button theme="fill_secondary" size="M" onClick={onClick} fullWidth loading={loading}>
      Показать еще
    </Button>
  );
};

ShowMoreBtn.displayName = 'ShowMoreBtn';
